import React from "react";
import { isEmpty } from "lodash";
import { FieldError, FieldLabel, PhoneField } from "../../../common/fields";

export const VERIFY_MODE = "VERIFY_MODE";

const editPhoneButtonAutomationId = "2fa-info-verifyphone-form--edit-phone-link";


const VerifyPhoneNumberField = (props) => {
  const { otpDetails, mode, editPhone, fieldLabel = "Phone", autoFocus = false, dataAutomationId = "" } = props;
  const onChange = (e) => {
    otpDetails.setStatus("");
    otpDetails.handleChange(e);
  };
  const onBlur = (e) => {
    if (e.relatedTarget?.type !== "button") {
      otpDetails.handleBlur(e);
    }
  }
  const phoneNumber = otpDetails.values.phone.replace(/[^0-9]/g, "");
  const formattedPhone = `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
  let content = <PhoneField
    autoFocus={autoFocus} // eslint-disable-line
    id="phone"
    name="phone"
    type="tel"
    label={fieldLabel}
    valid={!otpDetails.touched.phone || isEmpty(otpDetails.errors.phone)}
    onChange={onChange} onBlur={onBlur} value={phoneNumber} dataAutomationId={dataAutomationId}>
    {otpDetails.touched.phone && !isEmpty(otpDetails.errors.phone) &&
      <FieldError name="phone" errors={otpDetails.errors.phone}/>}
  </PhoneField>;

  if (mode === VERIFY_MODE) {
    content = <div className="security-info-column u--paddingXsmall-top">
      <FieldLabel label={fieldLabel}/>
      <div className="security-info-row">
        <div className="flex-row">
          <span>{formattedPhone}</span>
          <button onClick={editPhone} data-automation-id={editPhoneButtonAutomationId}
            className="u--paddingSmall-left u__default-link">
            Edit
          </button>
        </div>
        <span className="otp-sent-message alert-inline alert-inline--success inline">We&apos;ve sent you a verification code to {formattedPhone}</span>
      </div>
    </div>;
  }

  return content;
};

export default VerifyPhoneNumberField;